import { useState } from 'react';
import Clickable from '../Clickable';
import { ModalOverlay } from '@/components/Modal';
import styles from './styles/AuthModalV2.module.scss';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ResetPasswordForm from './ResetPasswordForm';

interface AuthModalProps {
  type: AuthModalType;
}

export const AUTH_MODAL_TYPES = ['login', 'register', 'password'] as const;
export type AuthModalType = (typeof AUTH_MODAL_TYPES)[number];

export function getAuthModalTypeFromPath(path: string): AuthModalType | undefined {
  return AUTH_MODAL_TYPES.find(t => path.includes(t));
}

export default function AuthModalV2({ type }: AuthModalProps) {
  const [formType, setFormType] = useState<AuthModalType>(type);

  return (
    <ModalOverlay onClose={() => undefined} overlayClassName={styles.Overlay}>
      <div className={styles.Content}>
        <div className={styles.FormContainer}>
          {formType === 'login' && <LoginForm register={() => setFormType('register')} forgotPassword={() => setFormType('password')} />}
          {formType === 'register' && <RegisterForm login={() => setFormType('login')} />}
          {formType === 'password' && (
            <ResetPasswordForm register={() => setFormType('register')} forgotPassword={() => setFormType('password')} />
          )}
        </div>
      </div>
      <div className={styles.TermsAndPrivacy}>
        By continuing, you agree to the SBLive Sports, Inc.&nbsp;
        <Clickable href="/privacy" target="_blank">
          Privacy Policy&nbsp;
        </Clickable>
        and&nbsp;
        <Clickable href="/terms" target="_blank">
          Terms of Service
        </Clickable>
      </div>
    </ModalOverlay>
  );
}
